export default __webpack_public_path__ + "static/base-plus-2-47268b51b729b208838a43d8b0a3ddfd.jpg";